import { useProducts } from '../../../../../../../features/product'
import { useProductGroups } from '../../../../../../../features/productGroup'
import { useCustomerGroups } from '../../../../../../../features/customerGroup'
import { useCustomers } from '../../../../../../../features/customer'
import { Company } from '../../../../../../../types/company/Company'
import { RecordType } from '../../../../../../../types/sales/sales'
import { BaseSalesItem } from './SalesChartFields'

const toSalesItem = ({ id, name }: { id: number | string; name: string }): BaseSalesItem => ({
  id,
  name
})

const useSalesRecordItems = (record: string | undefined, companyId?: Company['id']) => {
  const products = useProducts(companyId, data => data.map(toSalesItem), record === RecordType.products)
  const productGroups = useProductGroups(companyId, data => data.map(toSalesItem), record === RecordType.productGroups)
  const customerGroups = useCustomerGroups(
    companyId,
    data => data.map(toSalesItem),
    record === RecordType.customerGroups
  )
  const customers = useCustomers(companyId, data => data.map(toSalesItem), record === RecordType.customers)

  switch (record) {
    case RecordType.products:
      return { data: products.data ?? [], isLoading: products.isLoading }
    case RecordType.productGroups:
      return { data: productGroups.data ?? [], isLoading: productGroups.isLoading }
    case RecordType.customerGroups:
      return { data: customerGroups.data ?? [], isLoading: customerGroups.isLoading }
    case RecordType.customers:
      return { data: customers.data ?? [], isLoading: customers.isLoading }
    default:
      return { data: [] as BaseSalesItem[], isLoading: false }
  }
}

export default useSalesRecordItems
